<template>
  <div class="container py-5 text-center">
    <div v-if="loading">
      <b-spinner variant="primary" label="Loading..."></b-spinner>
      <p class="mt-3">Launching {{ appLabel }}...</p>
    </div>
    <div v-else-if="error">
      <md-icon class="text-danger" style="font-size: 48px">error</md-icon>
      <p class="mt-3 text-danger">{{ error }}</p>
      <b-btn variant="primary" :to="{ name: 'student-home' }">Return to Dashboard</b-btn>
    </div>
    <div v-else>
      <md-icon class="text-success" style="font-size: 48px">check_circle</md-icon>
      <p class="mt-3">{{ appLabel }} has been opened in a new tab.</p>
      <b-btn variant="primary" :to="{ name: 'student-home' }">Return to Dashboard</b-btn>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      loading: true,
      error: null,
    };
  },
  computed: {
    appType() {
      const name = this.$route.name || '';
      if (name.includes('games')) return 'games';
      if (name.includes('exams')) return 'exams';
      if (name.includes('flashcards')) return 'flashcards';
      return '';
    },
    appLabel() {
      const labels = { games: 'Skillform Games', exams: 'Exam Simulator', flashcards: 'Flashcards' };
      return labels[this.appType] || 'Skillform';
    },
  },
  async mounted() {
    try {
      const res = await this.provisionSkillformUser({ appType: this.appType });
      const data = res.data || res;
      if (data.redirect_url) {
        window.open(data.redirect_url, '_blank');
      }
      this.loading = false;
    } catch (err) {
      this.error = (err.response && err.response.data && err.response.data.message) || 'Failed to launch. Please try again.';
      this.loading = false;
    }
  },
  methods: {
    ...mapActions('skillform', ['provisionSkillformUser']),
  },
};
</script>
